import { tv } from "tailwind-variants";

export const layer = tv({
    base: [],

    variants: {
        layer: {
            "high-alert": "",
            "modal": "",
            "navigation": "",
            "overlay": "",
            "icons": "",
            "base": ""
        },
        layerAbove: {
            false: "",
            true: ""
        }
    },

    compoundVariants: [
        // DEFAULT LAYERS
        {
            layer: "high-alert",
            layerAbove: false,
            class: "tw:layer-high-alert/[0]"
        },
        {
            layer: "modal",
            layerAbove: false,
            class: "tw:layer-modal/[0]"
        },
        {
            layer: "navigation",
            layerAbove: false,
            class: "tw:layer-navigation/[0]"
        },
        {
            layer: "overlay",
            layerAbove: false,
            class: "tw:layer-overlay/[0]"
        },
        {
            layer: "icons",
            layerAbove: false,
            class: "tw:layer-icons/[0]"
        },
        {
            layer: "base",
            layerAbove: false,
            class: "tw:layer-base/[0]"
        },

        // INCREASED LAYERS
        {
            layer: "high-alert",
            layerAbove: true,
            class: "tw:layer-high-alert/[1]"
        },
        {
            layer: "modal",
            layerAbove: true,
            class: "tw:layer-modal/[1]"
        },
        {
            layer: "navigation",
            layerAbove: true,
            class: "tw:layer-navigation/[1]"
        },
        {
            layer: "overlay",
            layerAbove: true,
            class: "tw:layer-overlay/[1]"
        },
        {
            layer: "icons",
            layerAbove: true,
            class: "tw:layer-icons/[1]"
        },
        {
            layer: "base",
            layerAbove: true,
            class: "tw:layer-base/[1]"
        }
    ],

    defaultVariants: {
        layerAbove: false
    }
});
